/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import type {
  Client,
  RequestConfig,
  ResponseErrorConfig,
} from "@/shared/api/axiosInstance";
import type {
  QueryKey,
  QueryClient,
  QueryObserverOptions,
  UseQueryResult,
} from "@tanstack/react-query";
import type {
  GetApiV1IndividualpaymentFinancialPeopleFinancialpersonidAvailablePaymentMethodsQueryResponse,
  GetApiV1IndividualpaymentFinancialPeopleFinancialpersonidAvailablePaymentMethodsPathParams,
  GetApiV1IndividualpaymentFinancialPeopleFinancialpersonidAvailablePaymentMethodsQueryParams,
  GetApiV1IndividualpaymentFinancialPeopleFinancialpersonidAvailablePaymentMethods401,
  GetApiV1IndividualpaymentFinancialPeopleFinancialpersonidAvailablePaymentMethods500,
} from "../../types/individualPaymentLookupsController/GetApiV1IndividualpaymentFinancialPeopleFinancialpersonidAvailablePaymentMethods.ts";
import { queryOptions, useQuery } from "@tanstack/react-query";
import { getApiV1IndividualpaymentFinancialPeopleFinancialpersonidAvailablePaymentMethods } from "../../clients/individualPaymentLookupsController/getApiV1IndividualpaymentFinancialPeopleFinancialpersonidAvailablePaymentMethods.ts";

export const getApiV1IndividualpaymentFinancialPeopleFinancialpersonidAvailablePaymentMethodsQueryKey =
  (
    financialPersonId: GetApiV1IndividualpaymentFinancialPeopleFinancialpersonidAvailablePaymentMethodsPathParams["financialPersonId"],
    params?: GetApiV1IndividualpaymentFinancialPeopleFinancialpersonidAvailablePaymentMethodsQueryParams,
  ) =>
    [
      {
        url: "/api/v1/individualpayment/financial-people/:financialPersonId/available-payment-methods",
        params: { financialPersonId: financialPersonId },
      },
      ...(params ? [params] : []),
    ] as const;

export type GetApiV1IndividualpaymentFinancialPeopleFinancialpersonidAvailablePaymentMethodsQueryKey =
  ReturnType<
    typeof getApiV1IndividualpaymentFinancialPeopleFinancialpersonidAvailablePaymentMethodsQueryKey
  >;

export function getApiV1IndividualpaymentFinancialPeopleFinancialpersonidAvailablePaymentMethodsQueryOptions(
  financialPersonId: GetApiV1IndividualpaymentFinancialPeopleFinancialpersonidAvailablePaymentMethodsPathParams["financialPersonId"],
  params?: GetApiV1IndividualpaymentFinancialPeopleFinancialpersonidAvailablePaymentMethodsQueryParams,
  config: Partial<RequestConfig> & { client?: Client } = {},
) {
  const queryKey =
    getApiV1IndividualpaymentFinancialPeopleFinancialpersonidAvailablePaymentMethodsQueryKey(
      financialPersonId,
      params,
    );
  return queryOptions<
    GetApiV1IndividualpaymentFinancialPeopleFinancialpersonidAvailablePaymentMethodsQueryResponse,
    ResponseErrorConfig<
      | GetApiV1IndividualpaymentFinancialPeopleFinancialpersonidAvailablePaymentMethods401
      | GetApiV1IndividualpaymentFinancialPeopleFinancialpersonidAvailablePaymentMethods500
    >,
    GetApiV1IndividualpaymentFinancialPeopleFinancialpersonidAvailablePaymentMethodsQueryResponse,
    typeof queryKey
  >({
    enabled: !!financialPersonId,
    queryKey,
    queryFn: async ({ signal }) => {
      return getApiV1IndividualpaymentFinancialPeopleFinancialpersonidAvailablePaymentMethods(
        financialPersonId,
        params,
        { ...config, signal: config.signal ?? signal },
      );
    },
  });
}

/**
 * @description Migrado do legado IndividualPayment/GetAvailablePaymentMethodsByPerson. **(Requer Authorization para autenticação)**
 * @summary Métodos de pagamento disponíveis no plano do aluno (Requer Authorization para autenticação)
 * {@link /api/v1/individualpayment/financial-people/:financialPersonId/available-payment-methods}
 */
export function useGetApiV1IndividualpaymentFinancialPeopleFinancialpersonidAvailablePaymentMethods<
  TData =
    GetApiV1IndividualpaymentFinancialPeopleFinancialpersonidAvailablePaymentMethodsQueryResponse,
  TQueryData =
    GetApiV1IndividualpaymentFinancialPeopleFinancialpersonidAvailablePaymentMethodsQueryResponse,
  TQueryKey extends QueryKey =
    GetApiV1IndividualpaymentFinancialPeopleFinancialpersonidAvailablePaymentMethodsQueryKey,
>(
  financialPersonId: GetApiV1IndividualpaymentFinancialPeopleFinancialpersonidAvailablePaymentMethodsPathParams["financialPersonId"],
  params?: GetApiV1IndividualpaymentFinancialPeopleFinancialpersonidAvailablePaymentMethodsQueryParams,
  options: {
    query?: Partial<
      QueryObserverOptions<
        GetApiV1IndividualpaymentFinancialPeopleFinancialpersonidAvailablePaymentMethodsQueryResponse,
        ResponseErrorConfig<
          | GetApiV1IndividualpaymentFinancialPeopleFinancialpersonidAvailablePaymentMethods401
          | GetApiV1IndividualpaymentFinancialPeopleFinancialpersonidAvailablePaymentMethods500
        >,
        TData,
        TQueryData,
        TQueryKey
      >
    > & { client?: QueryClient };
    client?: Partial<RequestConfig> & { client?: Client };
  } = {},
) {
  const { query: queryConfig = {}, client: config = {} } = options ?? {};
  const { client: queryClient, ...resolvedOptions } = queryConfig;
  const queryKey =
    resolvedOptions?.queryKey ??
    getApiV1IndividualpaymentFinancialPeopleFinancialpersonidAvailablePaymentMethodsQueryKey(
      financialPersonId,
      params,
    );

  const query = useQuery(
    {
      ...getApiV1IndividualpaymentFinancialPeopleFinancialpersonidAvailablePaymentMethodsQueryOptions(
        financialPersonId,
        params,
        config,
      ),
      ...resolvedOptions,
      queryKey,
    } as unknown as QueryObserverOptions,
    queryClient,
  ) as UseQueryResult<
    TData,
    ResponseErrorConfig<
      | GetApiV1IndividualpaymentFinancialPeopleFinancialpersonidAvailablePaymentMethods401
      | GetApiV1IndividualpaymentFinancialPeopleFinancialpersonidAvailablePaymentMethods500
    >
  > & { queryKey: TQueryKey };

  query.queryKey = queryKey as TQueryKey;

  return query;
}
